module.exports = __webpack_public_path__ + "img/artzie_logo.dd995fc3.png";